import { get } from '.';

export function FindConferenceWebRtcSession(conferenceVid, options = {}) {
	return get<any>("/app/api/conferences/" + conferenceVid + "/web_rtc_session", options);
}